import { render, staticRenderFns } from "./EmployeeDirectoryBadgesTab.vue?vue&type=template&id=0febeb9a&scoped=true"
import script from "./EmployeeDirectoryBadgesTab.vue?vue&type=script&lang=js"
export * from "./EmployeeDirectoryBadgesTab.vue?vue&type=script&lang=js"
import style0 from "./EmployeeDirectoryBadgesTab.vue?vue&type=style&index=0&id=0febeb9a&prod&lang=css"
import style1 from "./EmployeeDirectoryBadgesTab.vue?vue&type=style&index=1&id=0febeb9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0febeb9a",
  null
  
)

export default component.exports